window.onload = function () {
    document.getElementById("loader").classList.add("hidden");
}

window.addEventListener('scroll', function() {
    try{
        var btt = document.getElementById('btt');

        if (window.scrollY >= 100) {
            btt.classList.remove('-mr-10');
            btt.classList.add('mr-4');
        } else {
            btt.classList.add('-mr-10');
            btt.classList.remove('mr-4');
        }
    }catch (e) {

    }

});


window.data = function () {

    function getThemeFromLocalStorage() {
        // if user already changed the theme, use it
        if (window.localStorage.getItem('dark')) {
            return JSON.parse(window.localStorage.getItem('dark'))
        }

        // else return their preferences
        return (
            !!window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches
        )
    }


    function setThemeToLocalStorage(value) {
        window.localStorage.setItem('dark', value)
    }

    function setFullscreenToLocalStorage(value) {
        window.localStorage.setItem('fullscreen', value)
    }

    return {
        playbackRates: [0.5, 0.75, 1, 1.25, 1.50, 1.75, 2],
        dark: getThemeFromLocalStorage(),
        fullscreen: false,
        toggleTheme() {
            this.dark = !this.dark
            setThemeToLocalStorage(this.dark)
        },

        toggleFullscreen() {
            this.fullscreen = !this.fullscreen

            if (screenfull.isEnabled) {
                screenfull.toggle();
            }

        },
        isSideMenuOpen: false,
        toggleSideMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen
        },
        closeSideMenu() {
            this.isSideMenuOpen = false
        },
        isNotificationsMenuOpen: false,
        toggleNotificationsMenu() {
            this.isNotificationsMenuOpen = !this.isNotificationsMenuOpen
        },
        closeNotificationsMenu() {
            this.isNotificationsMenuOpen = false
        },
        isProfileMenuOpen: false,
        toggleProfileMenu() {
            this.isProfileMenuOpen = !this.isProfileMenuOpen
        },
        closeProfileMenu() {
            this.isProfileMenuOpen = false
        },
        isPagesMenuOpen: false,
        togglePagesMenu() {
            this.isPagesMenuOpen = !this.isPagesMenuOpen
        },
        // Modal
        isModalOpen: false,
        trapCleanup: null,
        openModal() {
            this.isModalOpen = true
            this.trapCleanup = focusTrap(document.querySelector('#modal'))
        },
        closeModal() {
            this.isModalOpen = false
            this.trapCleanup()
        },
    }
}
